"use client"

import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion"
import { SUPPORT_EMAIL } from "@/lib/site-config"
import { useTranslations } from "@/components/i18n/use-translations";

export default function Terms() {
    const { messages } = useTranslations();
    const contactBody = messages.terms.sections.contact.body.replace("{email}", SUPPORT_EMAIL);

    return (
        <div className="mx-auto max-w-2xl px-4 py-8">
            <header className="space-y-3 text-center mb-8">
                <h1 className="text-3xl font-semibold tracking-tight text-white">{messages.terms.title}</h1>
                <p className="text-sm text-gray-400">{messages.terms.description}</p>
                <p className="text-xs text-gray-500">{messages.terms.updated}</p>
            </header>

            <Accordion type="single" collapsible className="w-full space-y-4">
                <AccordionItem value="eula" className="border border-cyan-700/40 rounded-lg px-4 bg-slate-900/30">
                    <AccordionTrigger className="text-lg font-semibold text-white hover:text-gray-300">{messages.terms.sections.eula.title}</AccordionTrigger>
                    <AccordionContent className="wrap-break-word text-sm text-gray-400">
                        {messages.terms.sections.eula.body}
                    </AccordionContent>
                </AccordionItem>

                <AccordionItem value="privacy" className="border border-cyan-700/40 rounded-lg px-4 bg-slate-900/30">
                    <AccordionTrigger className="text-lg font-semibold text-white hover:text-gray-300">{messages.terms.sections.privacy.title}</AccordionTrigger>
                    <AccordionContent className="wrap-break-word text-sm text-gray-400 whitespace-pre-line">
                        {messages.terms.sections.privacy.body}
                    </AccordionContent>
                </AccordionItem>

                <AccordionItem value="security" className="border border-cyan-700/40 rounded-lg px-4 bg-slate-900/30">
                    <AccordionTrigger className="text-lg font-semibold text-white hover:text-gray-300">{messages.terms.sections.security.title}</AccordionTrigger>
                    <AccordionContent className="wrap-break-word text-sm text-gray-400">
                        {messages.terms.sections.security.body}
                    </AccordionContent>
                </AccordionItem>

                <AccordionItem value="usage" className="border border-cyan-700/40 rounded-lg px-4 bg-slate-900/30">
                    <AccordionTrigger className="text-lg font-semibold text-white hover:text-gray-300">{messages.terms.sections.usage.title}</AccordionTrigger>
                    <AccordionContent className="wrap-break-word text-sm text-gray-400">
                        {messages.terms.sections.usage.body}
                    </AccordionContent>
                </AccordionItem>

                <AccordionItem value="contact" className="border border-cyan-700/40 rounded-lg px-4 bg-slate-900/30">
                    <AccordionTrigger className="text-lg font-semibold text-white hover:text-gray-300">{messages.terms.sections.contact.title}</AccordionTrigger>
                    <AccordionContent className="wrap-break-word text-sm text-gray-400">
                        {contactBody.split(SUPPORT_EMAIL)[0]}
                        <a
                            href={`mailto:${SUPPORT_EMAIL}`}
                            className="mx-1 inline-flex items-center font-semibold text-cyan-300 transition-colors hover:text-cyan-200"
                        >
                            {SUPPORT_EMAIL}
                        </a>
                        {contactBody.split(SUPPORT_EMAIL)[1] ?? ""}
                    </AccordionContent>
                </AccordionItem>
            </Accordion>
        </div>
    );
}
